import {
  ClipboardListIcon,
  ClockIcon,
  FolderOpenIcon,
  GraduationCapIcon,
  PackageSearchIcon,
  RepeatIcon,
  TimerIcon,
  WrenchIcon,
} from 'lucide-react'

export const CHECKOUT_URL = 'https://mega-pack-profes-electicidad.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/eFSb8Q5mSDsSvoFeij2epP/Imagen_de_Codex_28_sept_2026,_22_24_09.png'

export const PRODUCT_NAME = 'MEGA PACK PROFESOR TÉCNICO EN ELECTRICIDAD'
export const PACK_IMAGE_ALT = 'MEGA PACK PROFESOR TÉCNICO EN ELECTRICIDAD: 6 tomos digitales y 5 bonos incluidos'
export const PRICE = '$19.990'
export const BONUS_TOTAL = '$39.950'

export const META_PIXEL_ID = '2226605141499138'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: ClockIcon,
    title: 'HORAS PREPARANDO MATERIAL',
    desc: 'Buscas información, preparas ejercicios, diagramas, trabajos prácticos y explicaciones, pero organizar una sola clase puede llevarte mucho más tiempo del esperado.',
  },
  {
    icon: FolderOpenIcon,
    title: 'NO TIENES TODO EN UN SOLO LUGAR',
    desc: 'Planificaciones, circuitos, actividades, evaluaciones, prácticas, proyectos, rúbricas... terminas utilizando archivos y recursos diferentes para cada clase.',
  },
  {
    icon: PackageSearchIcon,
    title: 'TE FALTAN RECURSOS LISTOS',
    desc: 'Sabes qué quieres enseñar, pero necesitas actividades y materiales que puedas adaptar rápidamente al nivel de tus alumnos.',
  },
  {
    icon: RepeatIcon,
    title: 'REPITES EL MISMO TRABAJO',
    desc: 'Terminas creando nuevamente evaluaciones, prácticas y planificaciones que podrías tener organizadas en un sistema reutilizable.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'PLANIFICACIÓN Y SECUENCIAS DE CLASES DE ELECTRICIDAD',
    desc: 'Aprende a organizar la materia, definir objetivos, preparar secuencias didácticas y estructurar clases teóricas y prácticas de 40, 80 y 120 minutos.',
  },
  {
    title: 'CIRCUITOS E INSTALACIONES ELÉCTRICAS',
    desc: 'Material para enseñar fundamentos eléctricos, Ley de Ohm, circuitos serie, paralelo y mixtos, simbología, iluminación, instalaciones, interpretación de planos y detección de fallas.',
  },
  {
    title: 'MEDICIONES, HERRAMIENTAS Y MULTÍMETRO',
    desc: 'Organiza clases sobre herramientas, seguridad, tensión, resistencia, continuidad, corriente, multímetro, interpretación de resultados, prácticas y diagnóstico básico.',
  },
  {
    title: 'TABLEROS, TÉRMICAS, DIFERENCIALES Y PROTECCIONES',
    desc: 'Enseña tableros eléctricos, termomagnéticas, diferenciales, puesta a tierra, protecciones, organización de circuitos, interpretación de esquemas y diagnóstico.',
  },
  {
    title: 'TRABAJOS PRÁCTICOS DE TALLER PASO A PASO',
    desc: 'Accede a prácticas organizadas para trabajar herramientas, circuitos, Ley de Ohm, mediciones, iluminación, tableros, planos, diagnóstico y resolución de problemas.',
  },
  {
    title: 'PROYECTOS ELÉCTRICOS PARA REALIZAR CON ALUMNOS',
    desc: 'Desarrolla proyectos técnicos con tus estudiantes mediante propuestas de circuitos, maquetas, tableros didácticos, mediciones, iluminación, diagnóstico, presupuestos y desafíos integradores.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: '100 ACTIVIDADES DE ELECTRICIDAD LISTAS PARA USAR',
    desc: 'Banco de actividades sobre fundamentos, Ley de Ohm, circuitos, simbología, herramientas, multímetro, tableros, instalaciones y diagnóstico para utilizar en clase.',
    value: '$7.990',
  },
  {
    title: '50 EVALUACIONES + RESPUESTAS',
    desc: 'Evaluaciones listas para adaptar con opción múltiple, verdadero o falso, cálculos, interpretación de esquemas, diagnóstico, actividades prácticas y solucionarios.',
    value: '$5.990',
  },
  {
    title: 'PLANIFICACIONES DE CLASES EDITABLES',
    desc: 'Plantillas para organizar el año, unidades, meses, clases de 40, 80 y 120 minutos, trabajos prácticos, proyectos, evaluaciones y seguimiento.',
    value: '$6.990',
  },
  {
    title: 'BIBLIOTECA DE DIAGRAMAS Y ESQUEMAS ELÉCTRICOS',
    desc: 'Recursos visuales sobre circuitos, símbolos, mediciones, multímetro, tableros, protecciones, instalaciones y planos para explicar, proyectar o trabajar con alumnos.',
    value: '$8.990',
  },
  {
    title: 'RÚBRICAS Y PLANILLAS PARA EVALUAR ALUMNOS',
    desc: 'Herramientas para evaluar trabajos prácticos, taller, mediciones, seguridad, diagnóstico, proyectos y realizar seguimiento individual y general del curso.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: TimerIcon,
    title: 'MENOS HORAS PREPARANDO',
    desc: 'Deja de comenzar desde una hoja en blanco y utiliza estructuras, actividades y recursos que puedes adaptar a cada clase.',
  },
  {
    icon: WrenchIcon,
    title: 'MÁS MATERIAL PRÁCTICO',
    desc: 'Ten en un mismo sistema contenidos, circuitos, mediciones, trabajos de taller, evaluaciones, proyectos y recursos visuales.',
  },
  {
    icon: ClipboardListIcon,
    title: 'CLASES MÁS ORGANIZADAS',
    desc: 'Define qué enseñar, cómo explicarlo, qué actividad realizar y cómo evaluar lo aprendido siguiendo una estructura clara.',
  },
  {
    icon: GraduationCapIcon,
    title: 'MÁS TIEMPO PARA ENSEÑAR',
    desc: 'Reduce el trabajo repetitivo de crear materiales desde cero y dedica más tiempo a tus alumnos y al desarrollo de las clases.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Todas las semanas terminaba buscando ejercicios y armando material a último momento. Tener actividades, planificaciones y evaluaciones organizadas me ayudó a estructurar mucho mejor mis clases.',
    author: 'Martín Rodríguez',
    meta: 'Profesor técnico, 38 años · Buenos Aires, Argentina',
  },
  {
    quote:
      'Lo que más necesitaba eran ideas para las prácticas. Tener trabajos de taller y proyectos organizados por temas me dio una base que después puedo adaptar según cada curso.',
    author: 'Javier Pérez',
    meta: 'Maestro de taller, 44 años · Córdoba, Argentina',
  },
  {
    quote:
      'Doy electricidad y tenía mis materiales repartidos entre archivos, apuntes y actividades viejas. Con el sistema pude tener una estructura mucho más ordenada para preparar cada unidad.',
    author: 'Lucas Gómez',
    meta: 'Instructor técnico, 36 años · Rosario, Argentina',
  },
  {
    quote:
      'Las evaluaciones y rúbricas fueron de las partes que más me sirvieron. Antes preparaba cada examen prácticamente desde cero y ahora tengo modelos que puedo modificar según lo que enseñé.',
    author: 'Fernando Silva',
    meta: 'Profesor de electricidad, 41 años · Montevideo, Uruguay',
  },
  {
    quote:
      'Me interesó principalmente por los proyectos. Tener propuestas para que los alumnos apliquen circuitos, mediciones y diagnóstico me ayudó a sumar más trabajo práctico a las clases.',
    author: 'Carlos Méndez',
    meta: 'Instructor de electricidad, 47 años · Santiago, Chile',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito ser profesor de electricidad?',
    a: 'Está pensado principalmente para profesores, instructores, maestros de taller y personas que enseñan contenidos relacionados con electricidad.',
  },
  {
    q: '¿Qué incluye el sistema?',
    a: 'Incluye 6 tomos con material para planificación, circuitos, mediciones, tableros, trabajos prácticos y proyectos, más 5 bonos complementarios.',
  },
  {
    q: '¿Incluye actividades y evaluaciones?',
    a: 'Sí. Incluye actividades, evaluaciones, trabajos prácticos, proyectos, rúbricas y recursos visuales para adaptar.',
  },
  { q: '¿Los bonos tienen costo adicional?', a: 'No. Los 5 bonos están incluidos con tu compra.' },
  { q: '¿Es un pago único?', a: 'Sí. Realizas un único pago, sin mensualidades.' },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Al tratarse de contenido digital, recibirás las instrucciones de acceso después de completar tu compra.',
  },
  {
    q: '¿Puedo adaptar el material?',
    a: 'Sí. El sistema está pensado como material de apoyo que puedes adaptar al nivel, curso y necesidades de tus alumnos.',
  },
  {
    q: '¿Puedo utilizarlo a mi ritmo?',
    a: 'Sí. Puedes consultar y organizar el material según tus necesidades durante el ciclo lectivo.',
  },
  { q: '¿Dónde solicito soporte?', a: 'Puedes comunicarte mediante nuestro correo de soporte.' },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Martín G.', city: 'Buenos Aires', country: 'Argentina', minutes: 2 },
  { name: 'Laura P.', city: 'Córdoba', country: 'Argentina', minutes: 4 },
  { name: 'Diego F.', city: 'Rosario', country: 'Argentina', minutes: 6 },
  { name: 'Silvia R.', city: 'Mendoza', country: 'Argentina', minutes: 9 },
  { name: 'Gustavo M.', city: 'La Plata', country: 'Argentina', minutes: 12 },
  { name: 'Claudia V.', city: 'San Miguel de Tucumán', country: 'Argentina', minutes: 15 },
  { name: 'Ricardo A.', city: 'Mar del Plata', country: 'Argentina', minutes: 19 },
  { name: 'Patricia L.', city: 'Salta', country: 'Argentina', minutes: 23 },
  { name: 'Hernán S.', city: 'Neuquén', country: 'Argentina', minutes: 28 },
  { name: 'Mónica T.', city: 'Santa Fe', country: 'Argentina', minutes: 33 },
  { name: 'Pablo D.', city: 'Bahía Blanca', country: 'Argentina', minutes: 39 },
  { name: 'Andrea C.', city: 'Corrientes', country: 'Argentina', minutes: 45 },
]
